import React from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"

const LogoLink = styled(Link)`
  display: flex;
  flex: 100%;
  justify-content: center;
  margin: auto;
  background-color: ${(props) => props.background};
`

const SimpleSvg = styled.svg`
  position: relative;
  width: 150px;
  height: ${(props) => props.height};
  color: ${(props) => props.color};
  background-color: ${(props) => props.background};
  margin: auto;
  @media (min-width: 600px) {
    width: 200px;
  }
`
const MenuSvg = styled.svg`
  position: relative;
  width: 150px;
  height: 100%;
  @media (min-width: 640px) {
    width: auto;
  }
`

const LoaderSvg = styled.svg`
  margin: auto;
  position: relative;
  height: 80vh;
  width: 100%;
  color: ${(props) => props.color};
  background-color: ${(props) => props.background};
`

const Logo = (props) => {
  if (props.mod === "simple") {
    return (
      <SimpleSvg
        color={props.color}
        background={props.background}
        viewBox="0 0 500 500"
        // className={classes.SimpleSvg}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M287.335 277.679C287.335 277.679 287.873 283.59 294.323 287.621C300.772 291.654 315.822 302.134 322.004 346.209"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M316.092 340.297C316.092 340.297 318.241 354.541 324.96 364.753C331.679 374.966 331.778 403.156 326.304 419.578C325.498 421.997 329.259 426.296 330.335 428.446"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M322.81 379.535C322.81 379.535 302.172 376.292 294.861 399.69C293.517 403.99 295.935 404.528 295.935 404.528"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M300.504 397.541C300.504 397.541 292.979 421.997 309.641 435.166"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M323.348 277.141C323.348 277.141 331.41 227.423 361.241 252.953"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M356.135 253.223C356.135 253.223 376.022 269.885 383.548 290.848"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M385.428 285.472C385.428 285.472 397.522 319.334 392.148 336.266"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M397.253 334.116C397.253 334.116 400.21 373.353 379.785 387.597"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M385.966 387.059C385.966 387.059 387.041 403.99 359.897 423.877C359.897 423.877 344.579 433.015 333.022 422.803"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M367.154 364.215C367.154 364.215 354.523 399.421 332.216 386.79"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M366.348 305.091C366.348 305.091 380.86 339.491 357.478 367.44"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M328.453 284.396C328.453 284.396 322.541 276.872 330.066 273.647C337.591 270.423 365.004 274.454 363.659 311.272"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M105.492 139.183C105.492 73.1239 161.138 19.4922 229.882 19.4922C298.625 19.4922 354.271 73.1239 354.271 139.183C354.271 183.975 328.688 223.053 290.784 243.573V246.395C330.092 225.646 356.763 185.432 356.763 139.183C356.763 71.6588 299.912 17 229.882 17C159.852 17 103 71.6588 103 139.183C103 204.106 155.557 257.136 221.849 261.125V258.629C156.856 254.644 105.492 202.649 105.492 139.183Z"
          fill={props.color2}
        />
        <path
          d="M221.134 222.719C221.134 222.719 203.038 192.798 211.1 161.982C214.504 172.016 216.654 172.911 221.851 176.853C221.492 162.34 223.283 142.094 228.3 137.794C230.271 150.515 242.991 172.552 258.579 176.853C264.313 178.465 271.658 188.499 273.271 193.694"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M254.279 187.423C254.279 187.423 260.729 192.26 261.088 197.278"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M259.295 184.377C259.295 184.377 267 185.989 270.225 196.74C273.449 207.49 297.996 206.414 302.809 208.22C304.402 208.818 287.436 220.268 280.796 235.798C275.553 248.06 278.033 262.551 292.262 278.439"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M226.061 218.733C226.061 218.733 227.673 233.066 230.719 240.232C233.765 247.399 240.036 268.9 227.314 291.654"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M244.514 249.192C244.514 249.011 267.089 271.765 247.739 318.528"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M233.944 288.787C233.944 288.787 216.744 321.215 229.823 367.978"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M254.19 312.974C254.19 312.974 243.797 343.074 269.956 363.32"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M222.151 375.219C222.151 375.219 223.454 384.186 219.217 395.109C214.978 406.032 220.52 411.087 221.009 428.369C221.499 445.651 218.238 462.281 213.836 466.682"
          stroke={props.color}
          strokeWidth="1.54713"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M259.206 372.636C259.206 373.353 264.402 384.282 264.402 384.282"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M257.236 380.877C257.236 380.877 261.356 393.061 255.624 404.528C249.889 415.994 249.351 443.049 254.01 452.545"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M217.818 482.823C217.818 482.823 298.443 427.998 381.038 451.111"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </SimpleSvg>
    )
  } else if ("menu") {
    return (
      <LogoLink
        className={props.className}
        background={props.background}
        to="/"
        aria-label="Le Vignoble de Jape-loup"
      >
        <MenuSvg
          viewBox="0 0 440 206"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M56.879 55.61c-.237-.58-.553-1.37-.553-1.897 0-.237.29-.475.685-.5l1.317-.08v-.974c-1.975.025-3.293.078-4.32.078-1.028 0-2.37-.053-4.11-.078v.974l1.08.08c.896.078 1.317 1.159 1.633 1.897l6.297 15.042h2.002c.343-.844.632-1.712 1-2.582l5.48-13.12c.316-.763.66-1.185 1.239-1.237l.843-.08v-.974c-1.291.025-2.266.078-3.03.078-.764 0-1.765-.053-3.056-.078v.974l1.212.08c.527.025.975.236.975.71 0 .475-.37 1.476-.817 2.582l-3.741 9.3-4.136-10.195zM78.46 51.635c0-1.106.027-1.818.185-2.134.105-.211.395-.316 1.08-.369l.975-.078V48c-1.08.025-2.53.078-4.083.078-1.581 0-3.03-.053-4.11-.078v1.054l.975.078c.685.053.974.158 1.08.369.158.316.184 1.028.184 2.134v10.748c0 1.107-.026 1.818-.184 2.134-.106.211-.395.316-1.08.369l-.975.079v1.028c1.08-.027 2.529-.053 4.11-.053 1.554 0 3.002.026 4.083.053v-1.028l-.975-.079c-.685-.053-.975-.158-1.08-.369-.158-.316-.185-1.027-.185-2.134V51.635zM103.976 64.454c0-.66.185-.765 1.079-.949v-.896c-1.29.026-2.555.079-3.845.079-1.291 0-2.582-.053-3.873-.079v1.08l1.396.053c.843.027 1.502.158 1.502.975v3.477c-1.106.422-2.187.658-3.345.658-4.743 0-7.087-3.978-7.087-8.535 0-4.162 2.318-7.271 6.691-7.271 2.16 0 4.505.606 5.532 1.818l.132 2.266h1.027c.132-1.134.343-3.082.607-4.031l-.158-.29c-2.504-1.027-4.848-1.238-7.246-1.238-5.611 0-10.537 3.03-10.537 9.089 0 6.296 4.426 9.642 10.432 9.642 2.713 0 5.269-.607 7.693-1.555v-4.293zM112.728 70.92c0 1.107-.027 1.818-.185 2.134-.131.263-.395.396-1.08.448l-.974.079v.948c1.001-.026 2.028-.052 3.029-.052 1.002 0 2.002.025 3.003.052v-.948l-.974-.079c-.685-.052-.949-.185-1.08-.448-.158-.316-.185-1.027-.185-2.134v-10.3h.053l8.535 10.274a137.864 137.864 0 003.214 3.635l2.16.343.185-.105c-.027-.765-.079-1.713-.079-2.635v-11.96c0-1.106.027-1.818.185-2.134.131-.263.394-.395 1.079-.448l.975-.078v-.976c-1.001.027-2.002.08-3.003.08-1.001 0-2.028-.053-3.029-.08v.976l.974.078c.685.053.949.185 1.08.448.158.316.185 1.028.185 2.134v9.458l-8.22-9.59c-.948-1.107-1.817-2.344-2.713-3.504-.738.027-1.476.08-2.213.08-1.054 0-2.107-.053-3.161-.08v.976l.974.078c.685.053.949.185 1.08.448.158.316.185 1.028.185 2.134V70.92zM145.769 51.352c-6.033 0-10.01 3.319-10.01 9.536 0 6.007 3.582 9.195 9.483 9.195 6.033 0 10.011-3.293 10.011-9.511 0-6.006-3.583-9.22-9.484-9.22zm0 1.475c3.715 0 5.532 3.872 5.532 8.219 0 3.952-1.159 7.587-6.059 7.587-3.714 0-5.532-3.845-5.532-8.192 0-3.952 1.159-7.614 6.059-7.614zM165.142 56.772h.791c2.686 0 4.372.87 4.372 3.82 0 2.318-.921 3.978-3.74 3.978-.501 0-.896 0-1.423-.106v-7.692zm0-7.35a11.22 11.22 0 011.607-.105c1.923 0 3.003.764 3.003 2.819 0 2.555-1.475 3.266-3.819 3.266h-.791v-5.98zm-5.953-.448l.974.08c.685.052.948.183 1.08.447.158.316.185 1.028.185 2.134v11.802c0 .817-.106 1.265-.527 1.502l-.843.474v.58c.974-.026 2.055-.053 3.161-.053 1.264 0 2.529.026 3.715.053 4.293.105 7.322-2.372 7.322-5.612 0-3.055-1.922-4.241-5.294-4.373v-.052c2.423-.817 4.689-1.712 4.689-4.4 0-2.977-2.582-3.582-5.005-3.556-2.028.025-3.531.078-5.348.078-1.027 0-2.372-.053-4.109-.078v.974zM184.185 55.575c0-1.106.027-1.818.185-2.134.105-.211.395-.316 1.08-.369l.975-.078V51.94c-1.081.026-2.529.078-4.083.078-1.581 0-3.03-.052-4.111-.078v1.054l.976.078c.685.053.974.158 1.08.369.158.316.184 1.028.184 2.134v11.803c0 .816-.105 1.263-.526 1.501l-.844.474v.58c.975-.027 2.055-.053 3.161-.053 1.081 0 2.161.026 3.24.053 1.714.053 4.769.053 6.481-.053l.132-.211.29-4.372h-1.028l-.605 2.686c-.053.211-2.002.449-3.214.449-1.133 0-2.266-.027-3.373-.08V55.575zM200.383 58.143a70.777 70.777 0 013.373-.079c1.212 0 2.977.106 3.029.501l.211 1.976h.949l.369-3.741-.158-.184c-1.212-.106-2.372-.106-3.847-.08-1.502.027-3.293.08-5.77.08-1.027 0-2.37-.053-4.109-.08v.976l.974.078c.685.053.949.185 1.081.448.158.316.184 1.028.184 2.134v11.802c0 .816-.106 1.265-.527 1.501l-.843.475v.579c.975-.026 2.055-.052 3.162-.052 1.079 0 2.16.026 3.24.052 1.712.053 4.768.053 6.48-.052l.133-.211.289-4.162h-1.027l-.607 2.476c-.052.21-2.001.448-3.213.448-1.134 0-2.266-.027-3.373-.08v-7.033a20.143 20.143 0 011.765-.078h1.739c.923 0 1.423.236 1.501.974l.159 1.317h1.053c-.025-.948-.078-1.897-.078-2.845 0-.949.053-1.87.078-2.819h-1.053l-.159 1.501c-.051.501-.578.554-1.501.554h-1.739c-.578 0-1.158 0-1.765-.053v-6.323zM238.372 68.034c0 .816-.106 1.265-.527 1.501l-.843.474v.58c1.423-.026 2.713-.053 4.03-.053 1.318 0 2.608.027 3.926.053 5.637.105 10.959-3.398 10.959-9.773 0-5.901-3.24-8.22-8.904-8.22-2.319 0-5.058.08-6.771.08-1.027 0-2.37-.053-4.109-.08v.975l.974.079c.685.053.949.185 1.081.448.158.317.184 1.027.184 2.134v11.802zm3.714-14.015a11.242 11.242 0 011.607-.106c6.007 0 8.272 2.187 8.272 7.404 0 5.268-2.37 7.849-7.613 7.849-.737 0-1.501 0-2.266-.131V54.019zM264.3 49.606a72.13 72.13 0 013.373-.078c1.211 0 2.976.105 3.029.5l.211 1.976h.947l.369-3.741-.158-.184c-1.211-.105-2.37-.105-3.846-.079-1.501.026-3.293.079-5.769.079-1.027 0-2.371-.053-4.11-.079v.975l.975.079c.685.052.948.183 1.081.447.158.316.183 1.028.183 2.135v11.801c0 .817-.105 1.265-.527 1.502l-.843.474v.58c.976-.026 2.055-.053 3.162-.053 1.08 0 2.161.026 3.24.053 1.712.052 4.769.052 6.481-.053l.131-.211.29-4.162h-1.027l-.606 2.476c-.053.211-2.002.448-3.213.448a72.12 72.12 0 01-3.373-.079v-7.034a20.495 20.495 0 011.765-.079h1.739c.921 0 1.423.238 1.501.975l.158 1.317h1.054c-.026-.948-.078-1.896-.078-2.845 0-.948.052-1.87.078-2.819h-1.054l-.158 1.502c-.053.5-.58.552-1.501.552h-1.739c-.58 0-1.159 0-1.765-.051v-6.324z"
            fill={props.color ? props.color : "#efefef"}
          />
          <path
            d="M23.535 123.965c0-2.108.11-3.55.499-4.16.332-.555.998-.777 2.328-.833l2.663-.166v-1.663c-2.884.11-5.49.166-8.042.166-2.718 0-5.324-.056-8.208-.166v1.663l2.662.166c1.331.056 1.997.278 2.329.833.389.61.499 2.052.499 4.16v32.444c0 1.442-.166 3.438-.443 4.382-.444 1.275-1.276 1.829-2.385 1.829-1.387 0-2.551-.222-3.827-1.053l-.61.332.277 4.216c.222.056.5.11.888.11 3.217 0 5.99-2.052 7.93-4.436 3.717-4.548 3.44-9.151 3.44-12.756v-25.068zM44.255 135.414H42.48c-1.497 3.993-3.383 8.098-5.102 11.98l-9.872 22.461c-.61 1.442-1.665 2.607-2.995 2.718l-2.052.167v1.607c2.107-.054 4.214-.11 6.378-.11 1.608 0 3.715.056 6.378.11v-1.607l-2.052-.167c-1.72-.166-2.663-.388-2.663-1.552 0-.888 1.442-4.604 1.941-5.769l1.553-3.716h15.973l2.551 6.379c.555 1.331 1.165 2.773 1.165 3.549 0 .665-1.11 1.054-2.274 1.109l-2.606.167v1.607c2.994-.054 5.435-.11 7.376-.11 2.495 0 4.936.056 7.376.11v-1.607l-1.886-.167c-.998-.111-1.608-.832-2.218-1.885-.665-1.166-1.276-2.663-1.775-3.772l-13.421-31.502zm-9.317 23.904l7.043-16.527 6.988 16.527H34.938zM71.693 119.259c1.553-.388 3.162-.665 5.657-.665 5.491 0 8.986 2.495 8.986 8.263 0 4.715-3.495 8.264-7.987 8.264-1.22 0-2.44-.167-3.661-.555l.555 1.997c1.11.221 2.219.333 3.327.333 7.321 0 13.312-4.992 13.312-11.924 0-6.268-6.101-8.597-11.481-8.486-2.995.055-6.212.167-9.429.167-3.16 0-6.322-.112-9.983-.167v1.664l2.497.166c1.386.111 1.996.388 2.384.943.389.555.555 2.108.555 4.048v24.902c0 2.108-.112 3.55-.5 4.16-.332.555-.998.777-2.329.833l-2.662.166v1.608c2.884-.111 5.49-.111 8.208-.111 2.551 0 5.158 0 8.043.111v-1.608l-2.663-.166c-1.331-.056-1.997-.278-2.33-.833-.387-.61-.499-2.052-.499-4.16v-28.95zM99.259 135.076c0 2.107-.111 3.55-.499 4.159-.333.555-.998.721-2.33.833l-1.996.166v1.608c1.996-.055 3.827-.11 5.933-.11 3.44 0 7.82.055 12.092.11 4.103.056 8.485-.11 10.925-.11 0-2.996.333-6.434.887-9.097h-1.94c-.389 3.328-1.11 5.769-1.942 6.213-.998.554-6.655.72-11.202.72-1.499 0-3.107-.055-4.66-.443v-15.529c1.72-.166 3.772-.166 6.434-.166 3.383 0 5.269.221 5.878.665.278.166.389.665.445 1.387l.277 3.272h1.664c-.056-1.998-.167-4.104-.167-6.157 0-2.052.111-4.159.167-6.433h-1.664l-.277 2.884c-.056.721-.167 1.22-.445 1.442-.609.388-2.495.61-5.878.61-2.662 0-4.659-.056-6.434-.167v-14.807c1.553-.389 3.161-.445 4.66-.445 3.549 0 7.93.056 10.87 1.166.443.166.499.776.499 1.497v3.605h1.941c0-2.829.277-5.99.887-8.43a142.486 142.486 0 00-7.154-.166c-3.162 0-8.264.166-13.09.166-3.16 0-6.322-.112-9.372-.166v1.663l2.662.166c1.332.056 1.997.278 2.33.832.388.611.499 2.052.499 4.16v24.902zM180.519 123.307c0-2.106.111-3.549.499-4.159.333-.554.999-.776 2.33-.832l2.661-.166v-1.664c-2.883.111-5.49.167-8.041.167-2.717 0-5.324-.056-8.209-.167v1.664l2.663.166c1.331.056 1.996.278 2.33.832.387.61.499 2.053.499 4.159v26.289c0 1.498-.445 2.773-1.387 3.273l-1.719.886v1.221c1.441-.055 2.828-.111 4.713-.111 3.439 0 7.099.056 12.091.111 4.105.055 8.485-.111 10.926-.111.444-2.773.832-6.489 1.165-9.539h-1.775l-.665 2.773c-.278 1.164-.611 3.05-1.166 3.55-.942.886-7.708 1.053-12.256 1.053-1.498 0-3.106-.055-4.659-.444v-28.951zM226.879 174.962c12.146 0 21.463-9.483 21.463-21.407 0-12.313-8.43-18.969-20.298-18.969-12.867 0-20.854 8.819-20.854 20.244 0 12.423 8.43 20.132 19.689 20.132zm.277-38.046c10.316 0 15.252 7.376 15.252 18.358 0 10.205-4.493 17.414-13.754 17.414-10.982 0-15.529-10.204-15.529-19.91 0-9.095 4.38-15.862 14.031-15.862zM253.496 142.667c0 10.151 5.547 12.924 14.976 12.924 11.202 0 15.695-4.715 15.695-16.583v-16.029c0-2.108.111-3.549.499-4.16.332-.553.999-.72 2.33-.831l2.44-.167v-1.663c-2.44.055-4.438.166-6.656.166-1.996 0-4.214-.111-6.433-.166v1.663l2.44.167c1.332.111 1.997.278 2.33.831.388.611.499 2.052.499 4.16v17.748c0 9.207-5.436 11.48-11.425 11.48-7.321 0-11.425-2.274-11.425-10.149v-19.079c0-2.108.11-3.549.499-4.16.332-.553.998-.776 2.33-.831l2.661-.167v-1.663c-2.884.11-5.49.166-8.041.166-2.719 0-5.324-.056-8.209-.166v1.663l2.663.167c1.33.055 1.996.278 2.328.831.389.611.499 2.052.499 4.16v19.688zM301.02 106.454c1.552-.389 3.161-.665 5.656-.665 5.491 0 8.985 2.495 8.985 8.263 0 4.714-3.494 8.263-7.987 8.263-1.22 0-2.44-.166-3.66-.554l.555 1.997a16.91 16.91 0 003.327.332c7.322 0 13.311-4.991 13.311-11.924 0-6.267-6.101-8.597-11.481-8.485-2.994.056-6.211.166-9.428.166-3.161 0-6.323-.11-9.982-.166v1.663l2.495.167c1.386.111 1.997.388 2.384.943.389.555.555 2.108.555 4.048v24.903c0 2.107-.11 3.549-.499 4.159-.332.554-.998.776-2.329.832l-2.662.167v1.607c2.884-.11 5.49-.11 8.209-.11 2.551 0 5.157 0 8.041.11v-1.607l-2.663-.167c-1.33-.056-1.996-.278-2.328-.832-.389-.61-.499-2.052-.499-4.159v-28.951zM138.548 120.028c.129 0-1.081 3.286-1.513 3.849-.433.562 7.998 7.22 24.428 6.486l-.086-2.465s-7.217-.57-13.231-2.638c-5.396-1.855-9.66-5.232-9.598-5.232z"
            fill={props.color2 ? props.color2 : "#cecece"}
          />
          <path
            d="M386 115s.217 2.329 2.822 3.917c2.605 1.589 8.682 5.718 11.178 23.083M398 139s.754 5.655 3.113 9.71c2.359 4.055 2.393 15.248.472 21.769-.283.96 1.037 2.667 1.415 3.521"
            stroke={props.color ? props.color : "#efefef"}
            strokeWidth={2}
          />
          <path
            d="M400 155.061s-8.006-1.29-10.842 8.015c-.522 1.71.417 1.924.417 1.924M391.626 162s-2.779 9.75 3.374 15M401 114s3.192-18.953 15-9.221M414 105s7.98 6.643 11 15M425 118s4.481 13.333 2.49 20M429.941 137s1.174 15.407-6.941 21M424.998 158s.426 6.676-10.34 14.517c0 0-6.075 3.603-10.658-.423M418 149s-5.061 13.91-14 8.919M417.329 125s5.447 13.793-3.329 25"
            stroke={props.color ? props.color : "#efefef"}
            strokeWidth={2}
          />
          <path
            d="M402.884 117.533s-2.367-2.931.646-4.186c3.013-1.256 13.989.314 13.451 14.653"
            stroke={props.color ? props.color : "#efefef"}
            strokeWidth={2}
          />
          <path
            d="M313.992 59.548c0-26.248 22.147-47.558 49.509-47.558 27.36 0 49.507 21.31 49.507 47.558 0 17.797-10.182 33.324-25.268 41.478v1.121c15.645-8.244 26.26-24.222 26.26-42.6C414 32.719 391.373 11 363.501 11 335.628 11 313 32.718 313 59.548c0 25.796 20.918 46.867 47.303 48.452v-.992c-25.868-1.583-46.311-22.243-46.311-47.46z"
            stroke={props.color ? props.color : "#efefef"}
            strokeWidth={2}
          />
          <path
            d="M359.899 93s-7.324-11.979-4.062-24.316c1.378 4.017 2.248 4.375 4.352 5.953-.145-5.81.579-13.915 2.61-15.637.797 5.093 5.946 13.915 12.254 15.637 2.321.646 5.294 4.663 5.947 6.742M373 79s2.842 1.963 3 4"
            stroke={props.color ? props.color : "#efefef"}
            strokeWidth={2}
          />
          <path
            d="M375 78s3.179.634 4.511 4.863c1.33 4.228 11.46 3.805 13.446 4.516.657.235-6.344 4.739-9.084 10.848-2.164 4.823-1.14 10.523 4.731 16.773M362 91s.723 5.7 2.09 8.55c1.366 2.85 4.18 11.401-1.528 20.45M369 103c0-.073 10.204 9.116 1.458 28M365 119s-5.715 12.694-1.369 31M372.801 129s-4.086 11.957 6.199 20M360.911 153s.613 3.627-1.381 8.046c-1.993 4.419.613 6.463.844 13.455.231 6.991-1.304 13.718-3.374 15.499M375 152c0 .308 2 5 2 5M374.448 156s1.587 4.761-.62 9.241c-2.209 4.479-2.416 15.049-.622 18.759M359 196s32.108-21.99 65-12.72"
            stroke={props.color ? props.color : "#efefef"}
            strokeWidth={2}
          />
          <circle
            cx={369}
            cy={103}
            r={1}
            fill={props.color ? props.color : "#efefef"}
          />
        </MenuSvg>
      </LogoLink>
    )
  } else if (props.mod === "aside") {
    return (
      <svg
        className="w-full h-auto"
        fill="none"
        viewBox="0 0 500 500"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M274.908 192.837s.367 4.033 4.767 6.783c4.4 2.751 14.667 9.901 18.884 39.969M294.526 235.556s1.466 9.717 6.05 16.684c4.584 6.967 4.651 26.199.917 37.402-.55 1.65 2.016 4.583 2.75 6.05"
          stroke="#000"
          strokeWidth={1.7}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M299.109 262.324s-14.079-2.212-19.067 13.75c-.917 2.934.733 3.301.733 3.301M283.892 274.608s-5.134 16.684 6.233 25.668M299.476 192.47s5.5-33.918 25.851-16.501M321.844 176.153s13.567 11.367 18.701 25.668M341.828 198.154s8.25 23.101 4.584 34.652M349.895 231.339s2.017 26.768-11.917 36.485M342.195 267.457s.733 11.551-17.785 25.118c0 0-10.45 6.234-18.334-.733M329.361 251.873s-8.617 24.018-23.835 15.401M328.811 211.538s9.9 23.468-6.051 42.535M302.959 197.42s-4.033-5.133 1.1-7.333c5.134-2.2 23.835.55 22.918 25.668"
          stroke="#000"
          strokeWidth={1.7}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M150.853 98.354c0-45.066 37.962-81.654 84.86-81.654 46.897 0 84.859 36.588 84.859 81.654 0 30.558-17.453 57.217-43.311 71.216v1.925c26.816-14.155 45.011-41.589 45.011-73.14 0-46.066-38.784-83.355-86.559-83.355s-86.56 37.289-86.56 83.354c0 44.291 35.855 80.469 81.08 83.19v-1.703c-44.339-2.718-79.38-38.19-79.38-81.487z"
          fill="#000"
        />
        <path
          d="M229.745 155.343s-12.345-20.412-6.845-41.435c2.322 6.845 3.789 7.456 7.334 10.145-.245-9.901.977-23.713 4.4-26.646 1.344 8.678 10.022 23.712 20.656 26.646 3.912 1.1 8.923 7.945 10.023 11.489M252.357 131.264s4.4 3.3 4.645 6.723"
          stroke="#000"
          strokeWidth={1.7}
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M255.779 129.186s5.256 1.1 7.456 8.434 18.946 6.6 22.229 7.832c1.087.408-10.487 8.219-15.017 18.814-3.577 8.365-1.885 18.251 7.822 29.09M233.106 152.624s1.1 9.778 3.178 14.667c2.078 4.889 6.356 19.557-2.323 35.08M245.695 173.403c0-.123 15.401 15.4 2.2 47.302M238.484 200.415s-11.734 22.123-2.811 54.025M252.296 216.916s-7.09 20.534 10.756 34.346"
          stroke="#000"
          strokeWidth={1.7}
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M230.439 259.38s.889 6.117-2.002 13.569c-2.892 7.452.889 10.9 1.223 22.69.334 11.79-1.891 23.135-4.894 26.138"
          stroke="#000"
          strokeWidth={1.547}
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M255.718 257.618c0 .489 3.545 7.945 3.545 7.945M254.374 263.24s2.811 8.312-1.1 16.135c-3.912 7.822-4.279 26.279-1.101 32.757M227.483 332.788s55.003-37.402 111.35-21.634"
          stroke="#000"
          strokeWidth={1.7}
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M140.144 365.362c-.238-.583-.556-1.378-.556-1.908 0-.238.291-.477.689-.503l1.325-.08v-.98c-1.987.026-3.312.079-4.346.079-1.033 0-2.384-.053-4.133-.079v.98l1.086.08c.901.079 1.325 1.166 1.643 1.908l6.333 15.129h2.013c.345-.848.636-1.722 1.007-2.597l5.511-13.195c.318-.768.663-1.192 1.246-1.245l.848-.08v-.98c-1.299.026-2.279.079-3.047.079-.769 0-1.776-.053-3.074-.079v.98l1.219.08c.53.026.98.238.98.715s-.371 1.484-.821 2.597l-3.763 9.353-4.16-10.254zM161.85 361.364c0-1.112.027-1.828.186-2.146.106-.212.397-.318 1.086-.371l.981-.079v-1.06c-1.087.026-2.544.079-4.107.079-1.59 0-3.047-.053-4.134-.079v1.06l.981.079c.689.053.98.159 1.086.371.159.318.185 1.034.185 2.146v10.811c0 1.113-.026 1.828-.185 2.146-.106.212-.397.318-1.086.371l-.981.079v1.034c1.087-.027 2.544-.053 4.134-.053 1.563 0 3.02.026 4.107.053v-1.034l-.981-.079c-.689-.053-.98-.159-1.086-.371-.159-.318-.186-1.033-.186-2.146v-10.811zM187.513 374.257c0-.663.186-.769 1.086-.954v-.901c-1.298.026-2.57.079-3.868.079s-2.597-.053-3.895-.079v1.086l1.404.053c.848.027 1.511.159 1.511.981v3.497c-1.113.424-2.2.662-3.365.662-4.77 0-7.128-4.001-7.128-8.584 0-4.187 2.332-7.313 6.73-7.313 2.173 0 4.531.609 5.564 1.828l.133 2.279h1.033c.133-1.14.345-3.1.61-4.054l-.159-.292c-2.518-1.033-4.876-1.245-7.287-1.245-5.644 0-10.598 3.047-10.598 9.141 0 6.333 4.451 9.698 10.492 9.698 2.729 0 5.299-.61 7.737-1.564v-4.318zM196.316 380.761c0 1.113-.027 1.828-.186 2.146-.132.265-.397.398-1.086.451l-.98.079v.954c1.007-.026 2.04-.053 3.047-.053 1.007 0 2.013.026 3.02.053v-.954l-.98-.079c-.689-.053-.954-.186-1.086-.451-.159-.318-.186-1.033-.186-2.146v-10.36h.053l8.585 10.334a139.436 139.436 0 003.232 3.656l2.173.345.186-.106c-.027-.769-.08-1.723-.08-2.65v-12.029c0-1.113.027-1.829.186-2.147.132-.264.397-.397 1.086-.45l.98-.079v-.981c-1.007.027-2.013.08-3.02.08-1.007 0-2.04-.053-3.047-.08v.981l.98.079c.689.053.954.186 1.086.45.159.318.186 1.034.186 2.147v9.512l-8.267-9.645c-.954-1.113-1.828-2.358-2.729-3.524-.742.027-1.484.08-2.226.08-1.06 0-2.119-.053-3.179-.08v.981l.98.079c.689.053.954.186 1.086.45.159.318.186 1.034.186 2.147v10.81zM229.548 361.08c-6.068 0-10.068 3.338-10.068 9.591 0 6.042 3.603 9.248 9.538 9.248 6.068 0 10.069-3.312 10.069-9.566 0-6.041-3.604-9.273-9.539-9.273zm0 1.483c3.736 0 5.564 3.895 5.564 8.267 0 3.975-1.166 7.631-6.094 7.631-3.736 0-5.564-3.868-5.564-8.24 0-3.975 1.166-7.658 6.094-7.658zM249.033 366.531h.795c2.702 0 4.398.875 4.398 3.842 0 2.332-.927 4.001-3.762 4.001-.504 0-.901 0-1.431-.106v-7.737zm0-7.392c.556-.08 1.086-.106 1.616-.106 1.934 0 3.021.768 3.021 2.835 0 2.57-1.484 3.285-3.842 3.285h-.795v-6.014zm-5.988-.451l.98.08c.689.053.954.185 1.086.45.159.318.186 1.034.186 2.146v11.871c0 .821-.106 1.272-.53 1.51l-.848.477v.583a119.4 119.4 0 013.18-.053c1.271 0 2.543.026 3.736.053 4.318.106 7.365-2.385 7.365-5.644 0-3.073-1.934-4.266-5.325-4.398v-.053c2.437-.821 4.716-1.722 4.716-4.425 0-2.994-2.597-3.603-5.034-3.577-2.04.026-3.551.079-5.379.079-1.033 0-2.385-.053-4.133-.079v.98zM268.186 365.327c0-1.112.027-1.828.186-2.146.106-.212.397-.318 1.086-.371l.981-.079v-1.06c-1.087.026-2.544.079-4.107.079-1.59 0-3.047-.053-4.134-.079v1.06l.981.079c.689.053.98.159 1.086.371.159.318.186 1.034.186 2.146v11.871c0 .821-.106 1.271-.53 1.51l-.848.477v.583c.98-.027 2.066-.053 3.179-.053 1.087 0 2.173.026 3.259.053 1.723.053 4.796.053 6.518-.053l.133-.212.291-4.398h-1.033l-.609 2.702c-.053.212-2.014.451-3.233.451-1.139 0-2.279-.027-3.392-.08v-12.851zM284.478 367.91a71.58 71.58 0 013.392-.079c1.219 0 2.994.106 3.047.503l.212 1.988h.954l.371-3.763-.159-.185c-1.219-.106-2.385-.106-3.869-.08-1.51.027-3.312.08-5.803.08-1.033 0-2.384-.053-4.133-.08v.981l.98.079c.689.053.954.186 1.087.45.159.318.185 1.034.185 2.147v11.87c0 .821-.106 1.272-.53 1.51l-.848.477v.583c.981-.026 2.067-.053 3.18-.053 1.086 0 2.173.027 3.259.053 1.722.053 4.796.053 6.518-.053l.133-.212.291-4.186h-1.033l-.61 2.49c-.053.212-2.013.451-3.232.451-1.14 0-2.279-.027-3.392-.08v-7.074a20.36 20.36 0 011.775-.079h1.749c.928 0 1.431.238 1.51.98l.159 1.325h1.06c-.026-.954-.079-1.908-.079-2.862 0-.954.053-1.881.079-2.835h-1.06l-.159 1.51c-.052.504-.582.557-1.51.557h-1.749c-.582 0-1.165 0-1.775-.053v-6.36zM322.686 377.858c0 .821-.106 1.272-.53 1.51l-.848.477v.583c1.431-.026 2.729-.053 4.054-.053 1.325 0 2.623.027 3.948.053 5.67.106 11.023-3.418 11.023-9.83 0-5.935-3.259-8.267-8.956-8.267-2.332 0-5.087.08-6.81.08-1.033 0-2.384-.053-4.133-.08v.981l.98.079c.689.053.954.186 1.087.451.159.318.185 1.033.185 2.146v11.87zm3.736-14.096a11.366 11.366 0 011.616-.106c6.042 0 8.32 2.199 8.32 7.446 0 5.299-2.384 7.895-7.657 7.895-.742 0-1.51 0-2.279-.132v-15.103zM348.764 359.324a71.58 71.58 0 013.392-.079c1.218 0 2.994.106 3.047.503l.212 1.988h.953l.371-3.763-.159-.185c-1.218-.106-2.384-.106-3.868-.08-1.51.027-3.312.08-5.803.08-1.033 0-2.384-.053-4.133-.08v.981l.98.079c.689.053.954.185 1.087.45.159.318.185 1.034.185 2.147v11.87c0 .821-.106 1.272-.53 1.51l-.848.477v.583c.981-.026 2.067-.053 3.18-.053 1.086 0 2.173.026 3.259.053 1.722.053 4.796.053 6.518-.053l.132-.212.292-4.186h-1.033l-.61 2.49c-.053.212-2.014.451-3.232.451-1.14 0-2.279-.027-3.392-.08v-7.074a20.35 20.35 0 011.775-.08h1.749c.927 0 1.431.239 1.51.981l.159 1.324h1.06c-.026-.953-.079-1.907-.079-2.861 0-.954.053-1.881.079-2.835h-1.06l-.159 1.51c-.053.503-.583.556-1.51.556h-1.749c-.583 0-1.165 0-1.775-.052v-6.36z"
          fill="#000"
        />
        <path
          d="M106.607 434.112c0-2.12.111-3.57.502-4.184.334-.558 1.004-.781 2.342-.837l2.678-.167v-1.673c-2.901.111-5.522.167-8.088.167-2.734 0-5.355-.056-8.256-.167v1.673l2.678.167c1.338.056 2.008.279 2.342.837.391.614.502 2.064.502 4.184v32.632c0 1.45-.167 3.458-.446 4.407-.446 1.283-1.283 1.84-2.398 1.84-1.395 0-2.566-.223-3.85-1.059l-.613.334.279 4.24c.223.056.502.111.892.111 3.236 0 6.025-2.064 7.977-4.462 3.738-4.574 3.459-9.204 3.459-12.83v-25.213zM127.447 445.628h-1.785c-1.506 4.016-3.403 8.144-5.132 12.049l-9.929 22.591c-.614 1.45-1.674 2.622-3.012 2.733l-2.064.168v1.617c2.119-.055 4.239-.111 6.415-.111 1.617 0 3.737.056 6.415.111v-1.617l-2.064-.168c-1.73-.167-2.678-.39-2.678-1.561 0-.893 1.45-4.63 1.952-5.802l1.562-3.737h16.065l2.566 6.415c.558 1.339 1.172 2.789 1.172 3.57 0 .669-1.116 1.06-2.287 1.115l-2.622.168v1.617c3.012-.055 5.467-.111 7.419-.111 2.51 0 4.965.056 7.419.111v-1.617l-1.897-.168c-1.004-.111-1.617-.836-2.231-1.896-.669-1.172-1.283-2.678-1.785-3.793l-13.499-31.684zm-9.371 24.042l7.084-16.623 7.028 16.623h-14.112zM155.044 429.379c1.562-.39 3.18-.669 5.69-.669 5.522 0 9.037 2.51 9.037 8.311 0 4.742-3.515 8.312-8.033 8.312-1.227 0-2.454-.168-3.682-.558l.558 2.008c1.116.223 2.232.335 3.347.335 7.363 0 13.388-5.021 13.388-11.993 0-6.304-6.136-8.646-11.547-8.535-3.012.056-6.248.168-9.483.168-3.179 0-6.359-.112-10.041-.168v1.674l2.511.167c1.394.111 2.008.39 2.398.948.391.558.558 2.12.558 4.072v25.046c0 2.12-.112 3.57-.502 4.184-.335.558-1.004.781-2.343.837l-2.677.167v1.618c2.9-.112 5.522-.112 8.255-.112 2.566 0 5.188 0 8.089.112v-1.618l-2.678-.167c-1.339-.056-2.008-.279-2.343-.837-.39-.614-.502-2.064-.502-4.184v-29.118zM182.769 445.288c0 2.119-.112 3.57-.502 4.183-.335.558-1.004.725-2.343.837l-2.008.167v1.618c2.008-.056 3.849-.111 5.968-.111 3.459 0 7.865.055 12.161.111 4.127.056 8.534-.111 10.989-.111 0-3.013.334-6.471.892-9.149h-1.952c-.391 3.347-1.116 5.802-1.953 6.248-1.004.558-6.693.725-11.267.725-1.507 0-3.124-.056-4.686-.446v-15.619c1.729-.167 3.793-.167 6.471-.167 3.402 0 5.299.223 5.912.669.279.167.391.669.447 1.395l.279 3.291h1.673c-.056-2.009-.167-4.128-.167-6.192s.111-4.184.167-6.471h-1.673l-.279 2.901c-.056.725-.168 1.227-.447 1.45-.613.391-2.51.614-5.912.614-2.678 0-4.686-.056-6.471-.168V416.17c1.562-.391 3.179-.447 4.686-.447 3.57 0 7.976.056 10.933 1.172.446.167.502.781.502 1.506v3.626h1.952c0-2.845.279-6.025.893-8.479a144.106 144.106 0 00-7.196-.167c-3.18 0-8.312.167-13.165.167-3.179 0-6.359-.112-9.427-.167v1.673l2.678.167c1.339.056 2.008.279 2.343.837.39.614.502 2.064.502 4.184v25.046zM264.499 433.451c0-2.119.111-3.57.502-4.183.335-.558 1.004-.781 2.343-.837l2.677-.167v-1.674c-2.9.112-5.522.168-8.088.168-2.733 0-5.355-.056-8.256-.168v1.674l2.678.167c1.339.056 2.008.279 2.343.837.39.613.502 2.064.502 4.183v26.441c0 1.506-.447 2.789-1.395 3.291l-1.729.892v1.228c1.45-.056 2.845-.112 4.741-.112 3.459 0 7.14.056 12.161.112 4.128.055 8.534-.112 10.989-.112.446-2.789.836-6.526 1.171-9.594h-1.785l-.669 2.789c-.279 1.171-.614 3.068-1.172 3.57-.948.892-7.753 1.059-12.327 1.059-1.507 0-3.124-.055-4.686-.446v-29.118zM311.127 485.404c12.216 0 21.587-9.538 21.587-21.531 0-12.384-8.479-19.078-20.416-19.078-12.941 0-20.974 8.87-20.974 20.361 0 12.495 8.479 20.248 19.803 20.248zm.278-38.266c10.376 0 15.34 7.419 15.34 18.464 0 10.264-4.518 17.515-13.833 17.515-11.045 0-15.619-10.263-15.619-20.025 0-9.148 4.406-15.954 14.112-15.954zM337.898 452.923c0 10.209 5.579 12.998 15.062 12.998 11.267 0 15.786-4.742 15.786-16.679v-16.121c0-2.12.111-3.57.502-4.184.334-.557 1.004-.725 2.343-.836l2.454-.168v-1.673c-2.454.056-4.463.167-6.694.167-2.008 0-4.239-.111-6.47-.167v1.673l2.454.168c1.339.111 2.008.279 2.343.836.39.614.502 2.064.502 4.184v17.85c0 9.26-5.467 11.547-11.491 11.547-7.363 0-11.491-2.287-11.491-10.208v-19.189c0-2.12.111-3.57.502-4.184.334-.557 1.004-.781 2.343-.836l2.677-.168v-1.673c-2.901.111-5.522.167-8.088.167-2.734 0-5.355-.056-8.256-.167v1.673l2.678.168c1.338.055 2.008.279 2.342.836.391.614.502 2.064.502 4.184v19.802zM385.696 416.5c1.561-.391 3.179-.669 5.689-.669 5.523 0 9.037 2.51 9.037 8.311 0 4.741-3.514 8.311-8.033 8.311-1.227 0-2.454-.167-3.681-.557l.558 2.008c1.115.223 2.231.334 3.346.334 7.364 0 13.388-5.02 13.388-11.993 0-6.303-6.136-8.646-11.547-8.534-3.012.056-6.247.167-9.483.167-3.179 0-6.359-.111-10.04-.167v1.673l2.51.168c1.394.111 2.008.39 2.398.948.391.558.558 2.12.558 4.072v25.046c0 2.12-.111 3.57-.502 4.184-.334.557-1.004.78-2.343.836l-2.677.168v1.617c2.901-.111 5.522-.111 8.256-.111 2.566 0 5.187 0 8.088.111v-1.617l-2.678-.168c-1.338-.056-2.008-.279-2.342-.836-.391-.614-.502-2.064-.502-4.184V416.5z"
          fill="#AAA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M222.285 430.153c.13 0-1.087 3.305-1.522 3.871-.435.565 8.045 7.262 24.57 6.523l-.087-2.479s-7.259-.573-13.307-2.653c-5.428-1.866-9.716-5.262-9.654-5.262z"
          fill="#AAA"
        />
      </svg>
    )
  } else if (props.mod === "loader") {
    return (
      <LoaderSvg
        color={props.color}
        background={props.background}
        viewBox="0 0 500 500"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M287.335 277.679C287.335 277.679 287.873 283.59 294.323 287.621C300.772 291.654 315.822 302.134 322.004 346.209"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M316.092 340.297C316.092 340.297 318.241 354.541 324.96 364.753C331.679 374.966 331.778 403.156 326.304 419.578C325.498 421.997 329.259 426.296 330.335 428.446"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M322.81 379.535C322.81 379.535 302.172 376.292 294.861 399.69C293.517 403.99 295.935 404.528 295.935 404.528"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M300.504 397.541C300.504 397.541 292.979 421.997 309.641 435.166"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M323.348 277.141C323.348 277.141 331.41 227.423 361.241 252.953"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M356.135 253.223C356.135 253.223 376.022 269.885 383.548 290.848"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M385.428 285.472C385.428 285.472 397.522 319.334 392.148 336.266"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M397.253 334.116C397.253 334.116 400.21 373.353 379.785 387.597"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M385.966 387.059C385.966 387.059 387.041 403.99 359.897 423.877C359.897 423.877 344.579 433.015 333.022 422.803"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M367.154 364.215C367.154 364.215 354.523 399.421 332.216 386.79"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M366.348 305.091C366.348 305.091 380.86 339.491 357.478 367.44"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M328.453 284.396C328.453 284.396 322.541 276.872 330.066 273.647C337.591 270.423 365.004 274.454 363.659 311.272"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M105.492 139.183C105.492 73.1239 161.138 19.4922 229.882 19.4922C298.625 19.4922 354.271 73.1239 354.271 139.183C354.271 183.975 328.688 223.053 290.784 243.573V246.395C330.092 225.646 356.763 185.432 356.763 139.183C356.763 71.6588 299.912 17 229.882 17C159.852 17 103 71.6588 103 139.183C103 204.106 155.557 257.136 221.849 261.125V258.629C156.856 254.644 105.492 202.649 105.492 139.183Z"
          fill={props.color}
        />
        <path
          d="M221.134 222.719C221.134 222.719 203.038 192.798 211.1 161.982C214.504 172.016 216.654 172.911 221.851 176.853C221.492 162.34 223.283 142.094 228.3 137.794C230.271 150.515 242.991 172.552 258.579 176.853C264.313 178.465 271.658 188.499 273.271 193.694"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M254.279 187.423C254.279 187.423 260.729 192.26 261.088 197.278"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M259.295 184.377C259.295 184.377 267 185.989 270.225 196.74C273.449 207.49 297.996 206.414 302.809 208.22C304.402 208.818 287.436 220.268 280.796 235.798C275.553 248.06 278.033 262.551 292.262 278.439"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M226.061 218.733C226.061 218.733 227.673 233.066 230.719 240.232C233.765 247.399 240.036 268.9 227.314 291.654"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M244.514 249.192C244.514 249.011 267.089 271.765 247.739 318.528"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M233.944 288.787C233.944 288.787 216.744 321.215 229.823 367.978"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M254.19 312.974C254.19 312.974 243.797 343.074 269.956 363.32"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M222.151 375.219C222.151 375.219 223.454 384.186 219.217 395.109C214.978 406.032 220.52 411.087 221.009 428.369C221.499 445.651 218.238 462.281 213.836 466.682"
          stroke={props.color}
          strokeWidth="1.54713"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M259.206 372.636C259.206 373.353 264.402 384.282 264.402 384.282"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M257.236 380.877C257.236 380.877 261.356 393.061 255.624 404.528C249.889 415.994 249.351 443.049 254.01 452.545"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M217.818 482.823C217.818 482.823 298.443 427.998 381.038 451.111"
          stroke={props.color}
          strokeWidth="1.70018"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </LoaderSvg>
    )
  } else {
    return <></>
  }
}

export default Logo
